import Vue from 'vue'
import axios from 'axios';
import qs from 'qs';
import { Loading } from 'element-ui';
import router from '../router/index'
import store from '../store/index'
let api = {};

api.root_path = process.env.BASE_API;

api.axios_instance = null;
api.timeout = 60000;
api.withCredentials = true;

// showFullScreenLoading tryHideFullScreenLoading()要干的事儿就是将同一时刻的请求合并。
//声明一个变量needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading
let needLoadingRequestCount = 0;
let loading;
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}
export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}
function startLoading() {
  loading = Loading.service({
    lock: false,
    text: '加载中~~~',
    background: 'rgba(255, 255, 255, 0.3)',
    fullscreen:true
  })
}
function endLoading() {
  loading.close()
}
api.axios = function (vm) {
  if (!api.axios_instance) {
    var instance = axios.create({
      baseURL: api.root_path,
      timeout: api.timeout
    });
    // instance.defaults.headers.common['user-language'] = 'zh';
    // instance.defaults.headers.common['Authorization'] = 'Basic YW5kcm9pZDphbmRyb2lk' //登录接口
    // 添加请求拦截器
    instance.interceptors.request.use(function (config) {
      console.log(config.url);
      if(config.url=="/auth/oauth/token"){
        config.headers['Authorization'] = 'Basic YW5kcm9pZDphbmRyb2lk' //登录接口
      }
      // console.log(store.getters,"11111111111",store.getters['user/token'],'store.state.user.token');
      var token ='';
      if(store.state.user.token){
        token = store.state.user.token;
        config.headers['Authorization'] = token;
      }
      if(config.showLoading){
        showFullScreenLoading();
      }
      // 在发送请求之前做些什么
      // vm.$store.commit('updateLoadingStatus',true)
      return config;
    }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    });

    // 添加响应拦截器
    instance.interceptors.response.use(function (response) {
      if (response.config.showLoading) {
        tryHideFullScreenLoading()
      }
      // 对响应数据做点什么
      if (response.data.code=='00000') {
        return response.data;
      }else if (response.data.code=='A0200' || response.data.code=='A0230' || response.data.code=='A0231' || response.data.code=='A0232') {
        Vue.prototype.$message.warning({
          message: response.data.msg,
          offset: 100
        },true);
        store.dispatch('user/clearUserInfo');
        router.replace('/');
      } else {
        if(response.data.targetLanguageMessage){
          Vue.prototype.$message.warning({
            message: response.data.targetLanguageMessage,
            offset: 100
          },true);
        }else if (response.data.message) {
          Vue.prototype.$message.warning({
            message: response.data.message,
            offset: 100
          },true);
        } else {
          Vue.prototype.$message.warning({
            message: response.data.msg,
            offset: 100
          },true);
        }
        return false
      }
    }, function (error) {
      tryHideFullScreenLoading();
      console.log(error.response,'错误2')
      Vue.prototype.$message.warning(error.response.data.message);
      // 对响应错误做点什么
      return Promise.reject(error);
    });
    api.axios_instance = instance;
  }
  return api.axios_instance;
};
api.get = function (vm, url, params = {},showLoading) {
  let loading = null;
  if(showLoading){
    loading = showLoading.loading;
  }
  return api.axios(vm).get(url, {
    params: params,
    showLoading:loading
    // showLoading:false
  });
};
api.post = function (vm, url, data, params = {}) {
  return api.axios(vm).post(url, qs.stringify(data), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
   }
  );
};
api.postJson = function (vm, url, data,showLoading) {
  let loading = null;
  if(showLoading){
    loading = showLoading.loading;
  }
  return api.axios(vm).post(url, data, {
    headers: { 'Content-Type': 'application/json'},
    showLoading:loading
   }
  );
};
api.postJson2 = function (vm, url, data,params) {
  return api.axios(vm).post(url,data,{
    params: params
  }, 
  {
    headers: { 'Content-Type': 'application/json'},
   }
  );
};
// api.postParams = function (vm, url, data = {},params = {}) {
//   return api.axios(vm).post(url, {},{
//     params: params,
//   });
// };
api.postForm = function (vm, url, data,showLoading) {
  let loading = null;
  if(showLoading){
    loading = showLoading.loading;
  }
  return api.axios(vm).post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data'},
    showLoading:loading
   }
  );
};
api.put = function (vm, url, data, params = {}) {
  return api.axios(vm).put(url, qs.stringify(data), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
    params: params
  });
};
api.putJson = function (vm, url, data,params) {
  return api.axios(vm).put(url, data, {
    headers: { 'Content-Type': 'application/json'},
   }
  );
};
api.putJson2 = function (vm, url, data ,params) {
  return api.axios(vm).put(url, data,{
    params: params
  }, {
    headers: { 'Content-Type': 'application/json'},
   }
  );
};
api.delete = function (vm, url, params = {}) {
  return api.axios(vm).delete(url, {
    params: params
  });
};



export default api;



// WEBPACK FOOTER //
// ./src/api/api.js